export const referSubjectList = [
  {
    id: 1,
    trigger: "谁把奥利奥的夹心吃了，又把饼干放回去了？",
  },
  {
    id: 2,
    trigger: "这个锅是谁用完没洗？上面都长出青苔了！",
  },
  {
    id: 3,
    trigger: "冰箱里这瓶牛奶过期一个星期了，是谁的‘传家宝’？",
  },
  {
    id: 4,
    trigger: "公共的油和盐为什么一个月就用完了？有人拿来喝了吗？",
  },
  {
    id: 5,
    trigger: "谁动了我的专属餐具？我说了那是我吃饭的仪式感！",
  },
  {
    id: 6,
    trigger: "为什么水槽里总有别人的食物残渣？这里不是许愿池！",
  },
  {
    id: 7,
    trigger: "谁买的这个榴莲？！我们的房子需要戴防毒面具了！",
  },
  {
    id: 8,
    trigger: "我买的菜放冰箱里，为什么总被别人‘借’去当葱花蒜末用？",
  },
  {
    id: 9,
    trigger: "谁在凌晨一点用破壁机打果汁？我以为家里在搞装修！",
  },
  {
    id: 10,
    trigger: "谁老上完厕所不冲水？？",
  },
  {
    id: 11,
    trigger: "沙发缝里为什么能扫出这么多瓜子壳和指甲？",
  },
  {
    id: 12,
    trigger: "浴室的地漏又被头发堵住了！是谁的‘杰作’？？",
  },
  {
    id: 13,
    trigger: "为什么我晾的衣服总被别人挤到角落里，还是湿的？",
  },
  {
    id: 14,
    trigger: "谁家的闹钟从早上7点响到9点，人却不在？？？",
  },
  {
    id: 15,
    trigger: "卫生间的卷纸用完了，为什么不能由用完它的那个人换上新的？",
  },
  {
    id: 16,
    trigger: "这盆绿植快枯死了，到底轮到谁浇水了？",
  },
  {
    id: 17,
    trigger: "谁又把湿漉漉的雨伞带进屋里，弄得满地都是水？",
  },
  {
    id: 18,
    trigger: "这面镜子上的水渍是谁洗脸时溅上去的？",
  },
  {
    id: 19,
    trigger: "为什么总有人把内外穿的衣服/袜子扔在同一个洗衣篮里？",
  },
  {
    id: 20,
    trigger: "门口的鞋子能不能摆整齐一点？我们住的是家，不是盘丝洞！",
  },
  {
    id: 21,
    trigger: "谁在卫生间里一待就是一小时？是在里面修炼吗？",
  },
  {
    id: 22,
    trigger: "可以请不要在屋里剪指甲吗？它会飞到我的咖啡里！",
  },
  {
    id: 23,
    trigger: "谁又把我的充电器‘借’走了，还不承认？",
  },
  {
    id: 24,
    trigger: "你打电话/语音的时候可以小声一点吗？我把你和你妈的家常都听完了。",
  },
  {
    id: 25,
    trigger: "为什么你总是在我刚拖干净的地板上走来走去？",
  },
  {
    id: 26,
    trigger: "能不能别抖腿了？我感觉整个屋子都在地震。",
  },
  {
    id: 27,
    trigger: "谁睡觉打呼噜还磨牙？像一场重金属摇滚乐。",
  },
  {
    id: 28,
    trigger: "为什么你的快递盒子总是在客厅堆成山？",
  },
  {
    id: 29,
    trigger: "别再跟着我哼歌了好吗？而且你还总是跑调！",
  },
  {
    id: 30,
    trigger: "谁把我种在窗台上的薄荷叶揪了？我的‘莫吉托’计划泡汤了！",
  },
  {
    id: 31,
    trigger: "这个月的网费怎么这么贵？谁偷偷升级了套餐？",
  },
  {
    id: 32,
    trigger: "为什么Wi-Fi突然变得这么卡？是不是有人在偷偷下载几个T的东西？",
  },
  {
    id: 33,
    trigger: "谁把智能音箱的唤醒词改成了‘孙悟空’？",
  },
  {
    id: 34,
    trigger: "水电费账单出来了，上个月没人在家，为什么用了这么多电？",
  },
  {
    id: 35,
    trigger: "谁又在家庭共享相册里上传了奇怪的自拍/表情包？",
  },
  {
    id: 36,
    trigger: "公共账户里的钱怎么少了？谁买东西没记账？",
  },
  {
    id: 37,
    trigger: "为什么电视的‘猜你喜欢’里全是关于‘土味挖掘机’的视频？",
  },
  {
    id: 38,
    trigger: "我的游戏账号怎么显示在异地登录了？谁动了我的电脑？",
  },
  {
    id: 39,
    trigger: "可以别再用我的视频网站会员看付费电影了吗？我的观影记录都乱了！",
  },
  {
    id: 40,
    trigger: "谁把空调遥控器藏起来了？这是独裁！",
  },
  {
    id: 41,
    trigger: "谁的朋友昨天来访，吃了我们半包薯片，还用我的杯子喝水？",
  },
  {
    id: 42,
    trigger: "屋里为什么会有一只我不认识的猫？",
  },
  {
    id: 43,
    trigger: "地上这个脚印是谁的？看起来不属于我们任何一个人。",
  },
  {
    id: 44,
    trigger: "我发誓，我昨晚听到客厅有弹珠掉在地上的声音。",
  },
  {
    id: 45,
    trigger: "谁在半夜练习B-Box？我以为是洗衣机在甩干。",
  },
  {
    id: 46,
    trigger: "谁偷吃了我的外卖？？？",
  },
  {
    id: 47,
    trigger: "谁把所有东西都贴上了标签？连鸡蛋都贴了！",
  },
  {
    id: 48,
    trigger: "谁放屁了？！",
  },
  {
    id: 49,
    trigger: "墙上这个洞是谁弄的？看起来像用拳头打的。",
  },
  {
    id: 50,
    trigger: "如果世界末日明天就来，我们屋里最后的食物应该怎么分配？",
  },
];

export const getRandomSubjectList = (count = 6) => {
  return referSubjectList.sort(() => Math.random() - 0.5).slice(0, count);
};
